import React, { useContext } from "react";
import {
    DoughnutChart,
    StatisticsContainer,
    StatisticsContent,
    subscriptionChartOptions,
} from "modules/common";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    usersByCourses: number;
    usersByManifestations: number;
    usersByFarmingAndOther: number;
    usersByFruitAndOliveGrowing: number;
    usersByWineGrowing: number;
    usersByNews: number;
    usersByAdvices: number;
    usersByWeatherAlarm: number;
    total: number;
}
export const SubscriptionsStats: React.FC<Props> = ({
    usersByAdvices,
    usersByCourses,
    usersByFarmingAndOther,
    usersByFruitAndOliveGrowing,
    usersByWineGrowing,
    usersByManifestations,
    usersByNews,
    usersByWeatherAlarm,
    total,
}) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <StatisticsContainer title="Broj predbilježbi prema vrsti" className={lowVision ? "low-vision-darkgray" : ""}>
            <div className="statistics-chart">
                <DoughnutChart
                    options={subscriptionChartOptions}
                    data={[
                        usersByCourses,
                        usersByManifestations,
                        usersByFarmingAndOther,
                        usersByFruitAndOliveGrowing,
                        usersByWineGrowing,
                        usersByNews,
                        usersByAdvices,
                        usersByWeatherAlarm,
                    ]}
                    label="Ukupno"
                    value={total.toString()}
                />
            </div>
            <StatisticsContent>
                <div className="stats-row">
                    <div className="dot dot--lavender" />
                    <p className="stats-text">Vijesti</p>
                </div>
                <div className="stats-value">{usersByNews}</div>
                <div className="stats-row">
                    <div className="dot dot--pear" />
                    <p className="stats-text">Savjeti</p>
                </div>
                <div className="stats-value">{usersByAdvices}</div>
                <div className="stats-row">
                    <div className="dot dot--royalBlue" />
                    <p className="stats-text">Preporuka za zaštitu bilja: Ratarstvo i ostalo</p>
                </div>
                <div className="stats-value">{usersByFarmingAndOther}</div>
                <div className="stats-row">
                    <div className="dot dot--scooter" />
                    <p className="stats-text">
                        Preporuka za zaštitu bilja: Voćarstvo i maslinarstvo
                    </p>
                </div>
                <div className="stats-value">{usersByFruitAndOliveGrowing}</div>
                <div className="stats-row">
                    <div className="dot dot--error" />
                    <p className="stats-text">Preporuka za zaštitu bilja: Vinogradarstvo</p>
                </div>
                <div className="stats-value">{usersByWineGrowing}</div>
                <div className="stats-row">
                    <div className="dot dot--rajah" />
                    <p className="stats-text">Najave manifestacija</p>
                </div>
                <div className="stats-value">{usersByManifestations}</div>
                <div className="stats-row">
                    <div className="dot dot--terracota" />
                    <p className="stats-text">Evidencije i edukacije</p>
                </div>
                <div className="stats-value">{usersByCourses}</div>
                <div className="stats-row">
                    <div className="dot dot--primary" />
                    <p className="stats-text">Vremenski alarmi</p>
                </div>
                <div className="stats-value">{usersByWeatherAlarm}</div>
            </StatisticsContent>
        </StatisticsContainer>
    );
};
